import React from "react";
import "./Loading.css";

function Loading() {
  return (
    <div className="analyzeLoading">
      <div className="text-loading">Analyzing...</div>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}

export default Loading;
